// @ts-nocheck
import { Component } from '@angular/core';

@Component({
	selector: 'lbca-loading-dropdown',
	templateUrl: './loading-dropdown.component.html',
	styleUrl: './loading-dropdown.component.scss',
})
export class LoadingDropdownComponent {
	constructor() {}
}
